// removed by extract-text-webpack-plugin
module.exports = {"root":"online-exclusives__root","header":"online-exclusives__header","title":"online-exclusives__title"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/components/online-exclusives/styles.less
// module id = 493
// module chunks = 1